import { env } from './env';

export const API_CONFIG = {
  baseURL: env.apiBaseUrl,
  timeout: 10000,
} as const;
